import { render, staticRenderFns } from "./ListFeatures.vue?vue&type=template&id=7477a216&scoped=true&"
import script from "./ListFeatures.vue?vue&type=script&lang=js&"
export * from "./ListFeatures.vue?vue&type=script&lang=js&"
import style0 from "./ListFeatures.vue?vue&type=style&index=0&id=7477a216&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7477a216",
  null
  
)

export default component.exports